import React from 'react';
import classNames from 'classnames';

export interface CardProps {
  className?: string;
  type?: 'default' | 'complex';
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = (props: CardProps) => {
  const { type = 'default', className, children } = props;
  const cardClasses = classNames('ui-card', `ui-card--${type}`, className);

  return <div className={cardClasses}>{children}</div>;
};

export default Card;
